import { useQuery } from "react-query";

import { CorporationsListQueryID } from "@hooks/hooksConstants";
import { getCorporations } from "@services/corporations.service";

const useCorporations = () => useQuery([CorporationsListQueryID], () => getCorporations());

export default useCorporations;
